module.exports = __webpack_public_path__ + "static/media/tahlia_paris-2.3cf968d3.png";